import React from 'react';
import {Route, IndexRoute} from 'react-router';
import App from './components/app';

import HomeIndex from './components/index_home';
import UserLogin from './components/user/login';
import UserLogout from './components/user/logout';
import UserRegister from './components/user/register';
import UserProfile from './components/user/profile';
import ResetPassword from './components/user/reset_password';
import requireAuth from './utils/authenticated';

// my components
import DriverProfile from './components/driver/profile';
import EditCars from './components/editCars/editCars';
import FuelTracker from './components/fuelTracker/fuelTracker';
import AdminFuelTracker from './components/fuelTracker/adminFuelTracker';
import UsersListing from './components/users/usersListing';

export default (
    <Route path="/" component={App}>
        <IndexRoute component={HomeIndex}/>
        <Route path="/login" component={UserLogin}/>
        <Route path="/logout" component={UserLogout}/>
        <Route path="/register" component={UserRegister}/>
        <Route path="/reset" component={ResetPassword}/>
        <Route path="/profile" component={UserProfile} onEnter={requireAuth}/>
        <Route path="/driver-profile" component={DriverProfile} onEnter={requireAuth}/>
        <Route path="/edit-cars" component={EditCars} onEnter={requireAuth}/>
        <Route path="/fuel-tracker" component={FuelTracker} onEnter={requireAuth}/>
        <Route path="/admin-fuel-tracker" component={AdminFuelTracker} onEnter={requireAuth}/>
        <Route path="/users-listing" component={UsersListing} onEnter={requireAuth}/>
    </Route>
);



// WEBPACK FOOTER //
// ./src/app/routes.jsx